export default "__VITE_ASSET__C4It4iNC__"